import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { PlanService } from '../plan-repository/plan.service';
import { GenericResponse, GenericResponseData } from '../generic-response';
import { ShopApiService } from './shop-api.service';
import {
  PlanPriceModel,
  PlanSubscriptionModel,
  AutomaticDiscountPriceResponseModel,
} from 'src/app/core/model/object/shop-model';
import { UserDataService } from '../user-repository/user-data.service';
import { ShopDataService } from './shop-data.service';
import { PriceResponseModel } from 'src/app/core/model/api-response/shop-response-model';
import { RouteAnimationShared } from 'src/app/utils/route-animation-shared';

@Injectable({
  providedIn: 'root',
})
export class ShopService {
  constructor(
    private location: Location,
    private router: Router,
    private planService: PlanService,
    private shopApiService: ShopApiService,
    private userDataService: UserDataService,
    private shopDataService: ShopDataService,
    private routeAnimationShared: RouteAnimationShared
  ) {}

  back() {
    this.routeAnimationShared.showRouteAnimation();
    this.location.back();
  }

  backToMain() {
    // this.location.back();
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate(['/main']);
  }

  goToShopPage(scenario: string) {
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate(['/shop/' + scenario]);
  }

  checkTodayPlan(): Promise<GenericResponse> {
    let today = new Date();
    today = new Date(today.setHours(0, 0, 1, 0));
    return this.planService
      .checkThisDayPlan(today, false, false)
      .then((res) => {
        if (res.isSuccess()) {
          if (res.getData().getType() !== 'hasDiet') {
            return new GenericResponse(true);
          }
          return new GenericResponse(false);
        }
        return new GenericResponse(false);
      });
  }

  getPrices(discountCode?: string): Promise<GenericResponse> {
    return this.shopApiService.getPrices(discountCode).then((res) => {
      if (res.isSuccess()) {
        if (res.getData().getType() !== 'reward') {
          if (
            res.getData().getPlanPricesResponse().discountCode &&
            !discountCode
          ) {
            res = new GenericResponse(
              true,
              new GenericResponseData({
                type: 'autoDiscount',
                planPrices: res.getData().getPlanPricesResponse().plans,
              })
            );
          } else {
            res = new GenericResponse(
              true,
              new GenericResponseData({
                type: 'plan',
                planPrices: res.getData().getPlanPricesResponse().plans,
              })
            );
          }
        }
      }
      return res;
    });
  }

  // preparePrices(plans: PlanPriceModel[]): PlanPriceModel[] {
  //   plans.forEach((plan) => {
  //     if (plan.price.toString().length > 4) {
  //       plan.totalAmountString =
  //         plan.price.toString().substring(0, plan.price.toString().length - 4) +
  //         ',' +
  //         plan.price
  //           .toString()
  //           .substring(
  //             plan.price.toString().length - 4,
  //             plan.price.toString().length - 1
  //           );
  //     } else {
  //       plan.totalAmountString = plan.price
  //         .toString()
  //         .substring(0, plan.price.toString().length - 1);
  //     }

  //     const monthly = plan.price / plan.duration;
  //     if (monthly.toString().length > 4) {
  //       plan.monthlyAmountString =
  //         monthly.toString().substring(0, monthly.toString().length - 4) +
  //         ',' +
  //         monthly
  //           .toString()
  //           .substring(
  //             monthly.toString().length - 4,
  //             monthly.toString().length - 1
  //           );
  //     } else {
  //       plan.monthlyAmountString = monthly
  //         .toString()
  //         .substring(0, monthly.toString().length - 1);
  //     }
  //     if (
  //       plan.promotion &&
  //       new Date().getTime() > plan.promotion.startDate &&
  //       new Date().getTime() < plan.promotion.endDate
  //     ) {
  //       const remDays = Math.ceil(
  //         (plan.promotion.endDate - new Date().getTime()) /
  //           (24 * 60 * 60 * 1000)
  //       );
  //       plan.promotion.expireStatus =
  //         remDays === 1
  //           ? 'روز آخر'
  //           : remDays === 2
  //           ? '۱ روز باقیمانده'
  //           : remDays === 3
  //           ? '۲ روز باقیمانده'
  //           : '';
  //       const price = (plan.price * (100 - plan.promotion.percent)) / 100;
  //       if (price.toString().length > 4) {
  //         plan.promotion.totalPriceString =
  //           price.toString().substring(0, price.toString().length - 4) +
  //           ',' +
  //           price
  //             .toString()
  //             .substring(
  //               price.toString().length - 4,
  //               price.toString().length - 1
  //             );
  //       } else {
  //         plan.promotion.totalPriceString = price
  //           .toString()
  //           .substring(0, price.toString().length - 1);
  //       }
  //       const promotionMonthly = price / plan.duration;
  //       if (promotionMonthly.toString().length > 4) {
  //         plan.promotion.monthlyPriceString =
  //           promotionMonthly
  //             .toString()
  //             .substring(0, promotionMonthly.toString().length - 4) +
  //           ',' +
  //           promotionMonthly
  //             .toString()
  //             .substring(
  //               promotionMonthly.toString().length - 4,
  //               promotionMonthly.toString().length - 1
  //             );
  //       } else {
  //         plan.promotion.monthlyPriceString = promotionMonthly
  //           .toString()
  //           .substring(0, promotionMonthly.toString().length - 1);
  //       }
  //     }
  //   });

  //   return plans;
  // }

  // prepareAutoDiscountPrices(
  //   res: PriceResponseModel
  // ): AutomaticDiscountPriceResponseModel {
  //   const plans: PlanPriceModel[] = res.plans.map((a) => ({ ...a }));
  //   const discounts: PlanPriceModel[] = res.plans.map((a) => ({ ...a }));
  //   plans.forEach((plan) => {
  //     const price = (plan.price * 100) / (100 - res.discountPercent);
  //     if (price.toString().length > 4) {
  //       plan.totalAmountString =
  //         price.toString().substring(0, price.toString().length - 4) +
  //         ',' +
  //         price
  //           .toString()
  //           .substring(
  //             price.toString().length - 4,
  //             price.toString().length - 1
  //           );
  //     } else {
  //       plan.totalAmountString = price
  //         .toString()
  //         .substring(0, price.toString().length - 1);
  //     }

  //     const monthly = price / plan.duration;
  //     if (monthly.toString().length > 4) {
  //       plan.monthlyAmountString =
  //         monthly.toString().substring(0, monthly.toString().length - 4) +
  //         ',' +
  //         monthly
  //           .toString()
  //           .substring(
  //             monthly.toString().length - 4,
  //             monthly.toString().length - 1
  //           );
  //     } else {
  //       plan.monthlyAmountString = monthly
  //         .toString()
  //         .substring(0, monthly.toString().length - 1);
  //     }
  //   });
  //   discounts.forEach((plan) => {
  //     if (plan.price.toString().length > 4) {
  //       plan.totalAmountString =
  //         plan.price.toString().substring(0, plan.price.toString().length - 4) +
  //         ',' +
  //         plan.price
  //           .toString()
  //           .substring(
  //             plan.price.toString().length - 4,
  //             plan.price.toString().length - 1
  //           );
  //     } else {
  //       plan.totalAmountString = plan.price
  //         .toString()
  //         .substring(0, plan.price.toString().length - 1);
  //     }

  //     const monthly = plan.price / plan.duration;
  //     if (monthly.toString().length > 4) {
  //       plan.monthlyAmountString =
  //         monthly.toString().substring(0, monthly.toString().length - 4) +
  //         ',' +
  //         monthly
  //           .toString()
  //           .substring(
  //             monthly.toString().length - 4,
  //             monthly.toString().length - 1
  //           );
  //     } else {
  //       plan.monthlyAmountString = monthly
  //         .toString()
  //         .substring(0, monthly.toString().length - 1);
  //     }
  //   });

  //   return new AutomaticDiscountPriceResponseModel(plans);
  // }

  getPlanSubscription(force: boolean): Promise<GenericResponse> {
    return this.shopApiService.getPlanSubscription(force).then((res) => {
      if (res.isSuccess()) {
        let planSubscription: PlanSubscriptionModel;
        return this.shopDataService.getSubscription().then((result) => {
          if (result.expireDate > new Date().getTime()) {
            const remainingDays = Math.ceil(
              (result.expireDate - new Date().getTime()) / (24 * 60 * 60 * 1000)
            );
            planSubscription = new PlanSubscriptionModel(
              remainingDays,
              result.expireDate
            );
            return new GenericResponse(
              true,
              new GenericResponseData({ planSubscription })
            );
          } else {
            planSubscription = new PlanSubscriptionModel(0, result.expireDate);
            return new GenericResponse(
              true,
              new GenericResponseData({ planSubscription })
            );
          }
        });
      }
    });
  }

  purchase(id: string, discountCode: string) {
    const metrixUserId = localStorage.getItem('METRIX_CHART_CLIENT_ID')
      ? localStorage.getItem('METRIX_CHART_CLIENT_ID')
      : null;
    const metrixSessionId = localStorage.getItem('METRIX_SESSION_ID')
      ? localStorage.getItem('METRIX_SESSION_ID')
      : null;
    this.userDataService.getUser().then((user) => {
      let url = 'http://bentoapp.org/api/v2/payment/?';
      url += 'planId=' + id;
      url += '&userId=' + user._id;
      url += '&market=pwa';
      url += metrixUserId ? '&metrixUserId=' + metrixUserId : '';
      url += metrixSessionId ? '&metrixSessionId=' + metrixSessionId : '';
      if (discountCode != null) {
        url += '&discountCode=' + discountCode;
      }
      console.log('purchase ', url);
      window.location.href = url;
    });
  }
}
